import { useState, useCallback, useEffect} from "react";
import useGet from "../read/useGet";

const useDriverTrips = (company_employee_id) => {

    const [pageNo, setPageNo] = useState(0);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const initialParams = {
        page_number: 0,
        limit: 10,
        company_employee_id
    }

    const {
        list: driverTripsData,
        paramsObject,
        setGetListParams
    } = useGet({
        url: "trip/fetch_driver_trips",
        method: "get",
        initialData: initialParams
    });

    // Function to calculate trip duration
    const calculateTripDuration = (start_time, end_time) => {
        if (!start_time || !end_time) return "-";
        
        // Convert to numbers if they are strings
        const startTimeInSeconds = Number(start_time);
        const endTimeInSeconds = Number(end_time);
        
        // Calculate the difference in seconds
        const durationInSeconds = endTimeInSeconds - startTimeInSeconds;
        
        if (durationInSeconds < 0) return "-";
        
        // Convert to hours, minutes, seconds
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor((durationInSeconds % 3600) / 60);
        const seconds = Math.floor(durationInSeconds % 60);
        
        // Format the result
        if (hours > 0) {
            return `${hours}h ${minutes}m ${seconds}s`;
        } else if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
        } else {
            return `${seconds}s`;
        }
    };
    
    const isDriverTripsDataLoading = driverTripsData?.isLoading;

    const handlePageClick = (val) => {
        const data = {
            ...paramsObject,
            page_number: val.selected
        }
        setPageNo(val.selected);
        setGetListParams(data);
    }
    
    const handleDateRangeChange = (start, end) => {
        setFromDate(start);
        setToDate(end);
        
        const data = {
            ...paramsObject,
            page_number: 0
        };
        
        // Add from_date and to_date to params only if they exist
        if (start) {
            data.from_date = start;
        } else if (paramsObject.from_date) {
            delete data.from_date;
        }
        
        if (end) {
            data.to_date = end;
        } else if (paramsObject.to_date) {
            delete data.to_date;
        }
        
        setPageNo(0);
        setGetListParams(data);
    }

    return {
        driverTripsData,
        isLoading: isDriverTripsDataLoading,
        pageNo,
        paramsObject,
        fromDate,
        toDate,
        calculateTripDuration,
        handlePageClick,
        handleDateRangeChange,
        setGetListParams,
    }
};

export default useDriverTrips;